export const FILTERS = {
  ROLE: 'role',
  FRAMEWORKS: 'frameworks'
}


// WEBPACK FOOTER //
// ./src/config/overview/filters.js